import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";

const ManageRecommendedProducts = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    {
      id: "PRD001",
      name: "Apple iPhone 15 Pro",
      image: "/static/images/products/iphone15pro.jpg",
      status: true,
    },
    {
      id: "PRD002",
      name: "Sony WH-1000XM5 Headphones",
      image: "/static/images/products/sonyheadphones.jpg",
      status: false,
    },
    {
      id: "PRD003",
      name: "Nike Air Max 270",
      image: "/static/images/products/nike270.jpg",
      status: true,
    },
  ]);

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Recommended Products</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Recommended Products
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Products..."
            />
          </div>
        
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Product ID</TableCell>
                <TableCell>Product Details</TableCell>
                <TableCell>Recommended</TableCell>
             
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>
                   <div className="click_action user_block"
                    >
                      <figure>
                        <img src="/static/images/placeholder.png" alt="User" />
                      </figure>
                      <p>
                        <b>{row.name}</b>
                      </p></div>
                  </TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
               
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

    
    </>
  );
};

export default ManageRecommendedProducts;
